<template>
  <v-toolbar card color="transparent">
    <v-toolbar-side-icon>
      <v-icon class="grey--text">mdi-account</v-icon>
    </v-toolbar-side-icon>
    <v-toolbar-title class="subheading grey--text">
      {{ behavior.configuration.title || 'Assessment' }}
    </v-toolbar-title>

    <v-spacer />

    <can I="edit" a="Opportunity">
      <v-menu left max-width="30vw" v-model="removing">
        <v-btn flat icon color="error" slot="activator">
          <v-icon size="18px">mdi-delete</v-icon>
        </v-btn>

        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text
            >This will permanently remove the psychometric assessment behaviour.</v-card-text
          >
          <v-card-actions>
            <v-btn flat block @click="removing = false" color="grey">
              cancel
            </v-btn>
            <v-btn block color="error" @click="remove">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </can>

    <can I="edit" a="Opportunity">
      <v-btn flat icon @click="editing = true">
        <v-icon size="18px">mdi-pencil</v-icon>
      </v-btn>
    </can>

    <can I="edit" a="Opportunity">
      <v-dialog v-model="editing" max-width="700">
        <v-card>
          <v-card-title class="headline">
            Assessment Settings
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-select
                label="Provider"
                v-model="behavior.configuration.provider"
                required
                :items="[
                  { text: 'Top Talent Solutions', value: 'TopTalentSolutions' },
                  { text: 'Wits APS Score Calculator', value: 'APS' },
                  { text: 'Wamly Video Interview', value: 'Wamly' },
                  { text: 'Odyssey Assessment', value: 'Odyssey' },
                ]"
              />

              <v-text-field label="Title" v-model="behavior.configuration.title" />

              <v-text-field
                v-if="behavior.configuration.provider == 'TopTalentSolutions'"
                label="Username"
                required
                v-model="behavior.configuration.auth.username"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'TopTalentSolutions'"
                label="Password"
                type="password"
                required
                v-model="behavior.configuration.auth.password"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'Wamly'"
                label="Auth Token"
                required
                placeholder="8051a93e-fe32-47f4-98f7-8066f3c655e6"
                v-model="behavior.configuration.auth.token"
              />

              <v-text-field
                v-if="behavior.configuration.provider == 'TopTalentSolutions'"
                label="Project ID"
                required
                v-model="behavior.configuration.identity.project_id"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'TopTalentSolutions'"
                label="Model ID"
                required
                v-model="behavior.configuration.identity.model_id"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'Wamly'"
                label="Project ID"
                required
                placeholder="b818a835-0bd6-4ad9-8af7-d6a72c12776a"
                v-model="behavior.configuration.identity.project_id"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'Odyssey'"
                label="Project ID"
                required
                v-model="behavior.configuration.identity.project_id"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'Odyssey'"
                label="Auth Key"
                v-model="behavior.configuration.auth.key"
              />
              <v-text-field
                v-if="behavior.configuration.provider == 'Odyssey'"
                label="Auth UID"
                v-model="behavior.configuration.auth.uid"
              />
              <v-checkbox
                v-if="behavior.configuration.provider == 'Odyssey'"
                label="Show all results"
                v-model="behavior.configuration.complete"
              />
              <v-checkbox
                v-if="behavior.configuration.provider == 'Odyssey'"
                label="Required for completion"
                v-model="behavior.configuration.required"
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            ><v-spacer />
            <v-btn flat @click="cancel" color="grey">
              cancel
            </v-btn>
            <v-btn @click="submit" color="primary">
              {{ behavior.id ? 'Update' : 'Create' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </can>
  </v-toolbar>
</template>

<script>
const { transform, isObject } = _
const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)

// Vue Component
export default {
  props: {
    value: { type: Object },
  },
  data() {
    const applyTransform = obj =>
      transform(obj, (acc, val, key) => {
        const k = camelToSnakeCase(key)
        acc[k] = isObject(val) ? applyTransform(val) : val
      })
    const snakeCaseConfiguration = applyTransform(this.value.configuration)
    const configuration = Object.assign(
      { auth: {}, identity: {}, provider: 'TopTalentSolutions', title: '' },
      snakeCaseConfiguration
    )

    return {
      // Toggles
      editing: !this.value.id,
      removing: false,
      // Model
      behavior: Object.assign({}, this.value, { configuration }),
      // Validations
      valid: !!this.value.id,
    }
  },

  computed: {
    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },
  },

  watch: {
    'behavior.configuration.provider'(nextProvider, previousProvider) {
      if (!previousProvider || nextProvider == previousProvider) return

      this.behavior.configuration.auth = {}
    },
  },

  methods: {
    cancel() {
      this.editing = false
      this.$store.dispatch('admin/opportunities/fetch', this.$route.params.id)
    },
    submit() {
      if (this.behavior.id) {
        // Updating
        this.$store
          .dispatch('admin/opportunities/updateBehavior', this.behavior)
          .then(() => (this.editing = false))
      } else {
        // Creating
        this.$store
          .dispatch('admin/opportunities/createBehavior', this.behavior)
          .then(() => (this.editing = false))
      }
    },
    remove() {
      this.$store.dispatch('admin/opportunities/removeBehavior', this.behavior)
    },
  },
}
</script>
